import { createSelector } from 'reselect';
import { StoreState } from 'store/types';
import { ChartOfAccountsState } from './types';
import { CoaTemplate } from './models';

const selectChartOfAccounts = (app: StoreState): ChartOfAccountsState =>
  app.chartOfAccounts;

export const getChartOfAccountsLoading = createSelector(
  selectChartOfAccounts,
  (coa: ChartOfAccountsState): ChartOfAccountsState['loading'] => coa.loading
);

export const getChartOfAccountsError = createSelector(
  selectChartOfAccounts,
  (coa: ChartOfAccountsState): ChartOfAccountsState['error'] => coa.error
);
 
export const getChartOfAccountTemplates = createSelector(
  selectChartOfAccounts,
  (coa: ChartOfAccountsState) => coa.chartOfAccountsTemplates
);

export const getChartOfAccountsByCountry = createSelector(
  selectChartOfAccounts,
  (coa: ChartOfAccountsState): ChartOfAccountsState['selectedCountryAccounts'] =>
    coa.selectedCountryAccounts
);

export const getChartOfAccountsForConnection = (
  connectionId?: string | null
) =>
  createSelector(selectChartOfAccounts, (coa: ChartOfAccountsState) => {
    if (!connectionId) return [];
    const templates = coa.chartOfAccountsTemplates;
    if (!templates) return [];
    return templates as CoaTemplate[];
  });
